import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import { vedeDeconturileEchipei, vedeFlota } from '@b4l/shared'
import { useAuthStore } from './stores/auth'
import { useBootstrapAuth } from './hooks/useAuth'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AppShell } from './components/AppShell'
import { LoginPage } from './pages/LoginPage'
import { SamplingFormPage } from './pages/public/SamplingFormPage'
import { ReguliPage } from './pages/public/ReguliPage'
import { CastigatoriPage } from './pages/public/CastigatoriPage'
import { DezabonarePage } from './pages/public/DezabonarePage'
import { ChangePasswordPage } from './pages/ChangePasswordPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { AcasaPage } from './pages/acasa/AcasaPage'
import { AlertePage } from './pages/AlertePage'
import { CasutaMeaPage } from './pages/CasutaMeaPage'
import MailPage from './pages/MailPage'
import { CeSaSchimbatPage } from './pages/CeSaSchimbatPage'
import { GhidUiPage } from './pages/GhidUiPage'
import { SetariPage } from './pages/settings/SetariPage'
import { EFacturaPage } from './pages/EFacturaPage'
import TaskuriPage from './pages/taskuri/TaskuriPage'
import { TokenulMeuPage } from './pages/TokenulMeuPage'
import { RecurentePage } from './pages/taskuri/RecurentePage'
import { InboxPage } from './pages/InboxPage'
import { IntalniriPage } from './pages/orgJuridic/IntalniriPage'
import { ConcediiPage } from './pages/firma/ConcediiPage'
import { OnrcPage } from './pages/orgJuridic/OnrcPage'
import { ContractePage } from './pages/orgJuridic/ContractePage'
import { CazuriLegalePage } from './pages/orgJuridic/CazuriLegalePage'
import { AnalizeLaboratorPage } from './pages/orgJuridic/AnalizeLaboratorPage'
import { MatricePreturiPage } from './pages/MatricePreturiPage'
import { CereriPrintPage } from './pages/marketing/CereriPrintPage'
import { InfluenceriPage } from './pages/marketing/InfluenceriPage'
import { ColaborariPage } from './pages/marketing/ColaborariPage'
import { CampaniiEvenimentePage } from './pages/marketing/CampaniiEvenimentePage'
import { EvenimentPage } from './pages/marketing/EvenimentPage'
import { CereriMarfaPage } from './pages/marketing/CereriMarfaPage'
import { CampaniiPromoPage } from './pages/marketing/CampaniiPromoPage'
import { CampaniiPromoFluxPage } from './pages/marketing/CampaniiPromoFluxPage'
import { CampaniiMarketingPage } from './pages/marketing/CampaniiMarketingPage'
import { GeneratorEtichetePage } from './pages/marketing/GeneratorEtichetePage'
import { Randari3DPage } from './pages/marketing/Randari3DPage'
import { ListariCanalePage } from './pages/marketing/ListariCanalePage'
import { MaterialeMarketingPage } from './pages/marketing/MaterialeMarketingPage'
import { FurnizoriPage } from './pages/marketing/FurnizoriPage'
import { SamplingPage } from './pages/marketing/SamplingPage'
import { SamplingStandPage } from './pages/marketing/SamplingStandPage'
import { BannerHelperPage } from './pages/marketing/BannerHelperPage'
import { ClientiShopifyPage } from './pages/marketing/ClientiShopifyPage'
import { VouchereShopifyPage } from './pages/marketing/VouchereShopifyPage'
import { AtributieShopifyPage } from './pages/marketing/AtributieShopifyPage'
import { ComenziShopifyPage } from './pages/marketing/ComenziShopifyPage'
import { CohortShopifyPage } from './pages/marketing/CohortShopifyPage'
import { ProduseShopifyPage } from './pages/marketing/ProduseShopifyPage'
import { ArticoleSitePage } from './pages/marketing/ArticoleSitePage'
import { SetariFirmaPage } from './pages/settings/SetariFirmaPage'
import { SetariUtilizatoriPage } from './pages/settings/SetariUtilizatoriPage'
import { SetariRoluriAccesPage } from './pages/settings/SetariRoluriAccesPage'
import { SetariEmailPage } from './pages/settings/SetariEmailPage'
import { SetariProduseUserPage } from './pages/settings/SetariProduseUserPage'
import { SetariCentreCostPage } from './pages/settings/SetariCentreCostPage'
import { SetariAngajatiPage } from './pages/settings/SetariAngajatiPage'
import { SetariCategoriiCheltuieliPage } from './pages/settings/SetariCategoriiCheltuieliPage'
import { SetariInstrumentePromovarePage } from './pages/settings/SetariInstrumentePromovarePage'
import { ExpuneriPage } from './pages/marketing/ExpuneriPage'
import { DeconturiHubPage } from './pages/hr/DeconturiHubPage'
import { DeconturiEditorPage } from './pages/hr/DeconturiEditorPage'
import { OrdineDeplasarePage } from './pages/hr/OrdineDeplasarePage'
import { IncarcaBonPage } from './pages/hr/IncarcaBonPage'
import { SetariFiltreEmailPage } from './pages/settings/SetariFiltreEmailPage'
import { SetariShopifyPage } from './pages/settings/SetariShopifyPage'
import { SetariNotificariPage } from './pages/settings/SetariNotificariPage'
import { SetariAnafPage } from './pages/settings/SetariAnafPage'
import { SetariCanaleVanzarePage } from './pages/settings/SetariCanaleVanzarePage'
import { SetariEaPage } from './pages/settings/SetariEaPage'
import { SetariEmagPage } from './pages/settings/SetariEmagPage'
import { SetariAiPage } from './pages/settings/SetariAiPage'
import { SetariAgentiiMarketingPage } from './pages/settings/SetariAgentiiMarketingPage'
import { SetariComenziPage } from './pages/settings/SetariComenziPage'
import { CompliancePage, ComplianceRunDetailPage } from './pages/CompliancePage'
import { IncasariPage } from './pages/IncasariPage'
import { RambursuriCurieriPage } from './pages/compliance/rambursuri/RambursuriCurieriPage'
import { AlocareClientiPage } from './pages/operational/AlocareClientiPage'
import { CorespondentaPage } from './pages/operational/CorespondentaPage'
import { FacturiRestantePage } from './pages/FacturiRestantePage'
import { DashboardEmagPage } from './pages/emag/DashboardEmagPage'
import { VerificareEmagPage, VerificareEmagRunDetailPage } from './pages/emag/VerificareEmagPage'
import { VouchereEmagPage } from './pages/emag/VouchereEmagPage'
import { ComenziEmagPage } from './pages/emag/ComenziEmagPage'
import { IncasariEmagPage } from './pages/emag/IncasariEmagPage'
import { ComenziPage } from './pages/operational/ComenziPage'
import { ClientiiMeiPage } from './pages/clienti/ClientiiMeiPage'
import { ClientPage } from './pages/clienti/ClientPage'
import { ComandaEditPage } from './pages/operational/ComandaEditPage'
import { AgentiPreviewPage } from './pages/operational/AgentiPreviewPage'
import { CockpitVanzariPage } from './pages/operational/CockpitVanzariPage'
import { DiscounturiAcordatePage } from './pages/vanzari/DiscounturiAcordatePage'
import { InventarDiferentePage } from './pages/operational/InventarDiferentePage'
import { IntrariGestiunePage } from './pages/operational/IntrariGestiunePage'
import { ExpedieriAwbPage } from './pages/operational/ExpedieriAwbPage'
import { TaxeImpozitePage } from './pages/bani/TaxeImpozitePage'
import { VerificareCifrePage } from './pages/bani/VerificareCifrePage'
import { RompetrolPage } from './pages/operational/RompetrolPage'
import { ProceseVerbalePage } from './pages/operational/flota/ProceseVerbalePage'
import { PvPage } from './pages/operational/flota/PvPage'
import { MasinaMeaPage, MasinaPage, SoferPage } from './pages/operational/flota/CronologiiPage'
import { SellOutPage } from './pages/operational/SellOutPage'
import { FacturiVanzareEmagPage } from './pages/emag/FacturiVanzareEmagPage'
import { FacturiCumparareEmagPage } from './pages/emag/FacturiCumparareEmagPage'
import { FacturiComisioaneAmazonPage } from './pages/amazon/FacturiComisioaneAmazonPage'
import { FacturiVanzareAmazonPage } from './pages/amazon/FacturiVanzareAmazonPage'
import { IncasariAmazonPage } from './pages/amazon/IncasariAmazonPage'
import { SetariMetaPage } from './pages/settings/SetariMetaPage'
import { MetaAdsPage } from './pages/marketing/MetaAdsPage'

/**
 * Deconturile tuturor sunt ale echipei de HR si contabilitate (14.10.2026). Cine intra pe adresa
 * fara sa fie in ea ajunge la propriul decont. Serverul refuza oricum — aici e doar drumul.
 */
function DoarEchipaDeconturi() {
  const role = useAuthStore((s) => s.user?.role)
  return vedeDeconturileEchipei(role) ? <Outlet /> : <Navigate to="/hr/incarca-bon" replace />
}

/** Flota Rompetrol: nu pentru agentii din Vanzari (28.10.2026). Serverul refuza oricum. */
function DoarCineVedeFlota() {
  const role = useAuthStore((s) => s.user?.role)
  return vedeFlota(role) ? <Outlet /> : <Navigate to="/" replace />
}

export function App() {
  useBootstrapAuth()

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/*
        Formularul de sampling de la codul QR. Singura pagina publica din aplicatie: in afara
        ProtectedRoute, deci fara sesiune si fara AppShell. Cine o muta inauntru rupe fluxul.
      */}
      <Route path="/s/:slug" element={<SamplingFormPage />} />
      {/* Regulamentul, liber: se citeste fara inscriere si fara bilet la eveniment. */}
      <Route path="/s/:slug/reguli" element={<ReguliPage />} />
      <Route path="/s/:slug/castigatori" element={<CastigatoriPage />} />
      {/*
        Dezabonarea, in afara lui `/s/<slug>`: linkul pleaca in mesaje care nu tin de o campanie
        anume, iar omul trebuie sa se poata dezabona chiar daca actiunea s-a inchis intre timp.
      */}
      <Route path="/dezabonare/:contactId/:token" element={<DezabonarePage />} />
      <Route
        path="/change-password"
        element={
          <ProtectedRoute allowMustChange>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />

      <Route
        element={
          <ProtectedRoute>
            <AppShellOutlet />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<AcasaPage />} />
        <Route path="/alerte" element={<AlertePage />} />
        {/* Fara permisiune: e contul lui de mail, nu o setare de firma. */}
        <Route path="/mailul-meu" element={<CasutaMeaPage />} />
        {/* Tokenul personal de API: doar cu dreptul personal `tasks.export:token` (serverul il cere). */}
        <Route path="/tokenul-meu" element={<TokenulMeuPage />} />
        <Route path="/mail" element={<MailPage />} />
        <Route path="/ce-s-a-schimbat" element={<CeSaSchimbatPage />} />
        {/* Galeria pieselor comune de interfata. Fara date, doar exemple; o vad adminii. */}
        <Route path="/ghid-ui" element={<GhidUiPage />} />
        {/* Toate setarile intr-o pagina; o vede cine are macar o setare (vezi SECTIUNI_SETARI). */}
        <Route path="/setari" element={<SetariPage />} />
        <Route path="/efactura" element={<EFacturaPage />} />
        <Route path="/preturi" element={<MatricePreturiPage />} />
        <Route path="/marketing/cereri-print" element={<CereriPrintPage />} />
        <Route path="/marketing/promo" element={<CampaniiPromoPage />} />
        <Route path="/marketing/camppromo" element={<CampaniiPromoFluxPage />} />
        <Route path="/marketing/campanii-mk" element={<CampaniiMarketingPage />} />
        <Route path="/marketing/influenceri" element={<InfluenceriPage />} />
        <Route path="/marketing/colaborari" element={<ColaborariPage />} />
        <Route path="/marketing/evenimente" element={<CampaniiEvenimentePage />} />
        <Route path="/marketing/evenimente/:id" element={<EvenimentPage />} />
        <Route path="/marketing/cereri-marfa" element={<CereriMarfaPage />} />
        <Route path="/marketing/etichete" element={<GeneratorEtichetePage />} />
        <Route path="/marketing/randari" element={<Randari3DPage />} />
        <Route path="/marketing/listari" element={<ListariCanalePage />} />
        <Route path="/marketing/materiale" element={<MaterialeMarketingPage />} />
        <Route path="/marketing/furnizori" element={<FurnizoriPage />} />
        <Route path="/marketing/sampling" element={<SamplingPage />} />
        <Route path="/marketing/expuneri" element={<ExpuneriPage />} />
        <Route path="/marketing/sampling-stand" element={<SamplingStandPage />} />
        <Route path="/marketing/banner-helper" element={<BannerHelperPage />} />
        <Route path="/marketing/shopify/clienti" element={<ClientiShopifyPage />} />
        <Route path="/marketing/shopify/vouchere" element={<VouchereShopifyPage />} />
        <Route path="/marketing/shopify/atributie" element={<AtributieShopifyPage />} />
        <Route path="/marketing/shopify/comenzi" element={<ComenziShopifyPage />} />
        <Route path="/marketing/shopify/produse" element={<ProduseShopifyPage />} />
        <Route path="/marketing/shopify/articole-site" element={<ArticoleSitePage />} />
        <Route path="/marketing/shopify/cohort" element={<CohortShopifyPage />} />
        <Route path="/task-uri" element={<TaskuriPage />} />
        <Route path="/task-uri/recurente" element={<RecurentePage />} />
        <Route path="/inbox" element={<InboxPage />} />
        {/* „Istoric e-mailuri" a iesit odata cu Mail (22.10.2026): ce trimite omul e in Mail. */}
        <Route path="/email-istoric" element={<Navigate to="/mail" replace />} />
        <Route path="/intalniri" element={<IntalniriPage />} />
        <Route path="/concedii" element={<ConcediiPage />} />
        <Route path="/onrc" element={<OnrcPage />} />
        <Route path="/contracte" element={<ContractePage />} />
        <Route path="/legal" element={<CazuriLegalePage />} />
        <Route path="/lab" element={<AnalizeLaboratorPage />} />
        <Route path="/setari/firma" element={<SetariFirmaPage />} />
        <Route path="/setari/utilizatori" element={<SetariUtilizatoriPage />} />
        <Route path="/setari/roluri-acces" element={<SetariRoluriAccesPage />} />
        <Route path="/setari/produse" element={<SetariProduseUserPage />} />
        <Route path="/marketing/meta-ads" element={<MetaAdsPage />} />
        <Route path="/setari/meta" element={<SetariMetaPage />} />
        <Route path="/setari/centre-cost" element={<SetariCentreCostPage />} />
        <Route path="/setari/angajati" element={<SetariAngajatiPage />} />
        <Route path="/setari/categorii-cheltuieli" element={<SetariCategoriiCheltuieliPage />} />
        <Route path="/setari/instrumente-promovare" element={<SetariInstrumentePromovarePage />} />
        <Route path="/setari/email" element={<SetariEmailPage />} />
        <Route path="/setari/filtre" element={<SetariFiltreEmailPage />} />
        <Route path="/setari/shopify" element={<SetariShopifyPage />} />
        <Route path="/setari/notificari" element={<SetariNotificariPage />} />
        <Route path="/setari/comenzi" element={<SetariComenziPage />} />
        <Route path="/setari/anaf" element={<SetariAnafPage />} />
        <Route path="/setari/canale-vanzare" element={<SetariCanaleVanzarePage />} />
        <Route path="/setari/ea" element={<SetariEaPage />} />
        <Route path="/setari/emag" element={<SetariEmagPage />} />
        <Route path="/setari/ai" element={<SetariAiPage />} />
        <Route path="/setari/agentii-marketing" element={<SetariAgentiiMarketingPage />} />
        <Route path="/compliance/spv-ea" element={<CompliancePage />} />
        <Route path="/compliance/spv-ea/runs/:id" element={<ComplianceRunDetailPage />} />
        <Route path="/compliance/incasari" element={<IncasariPage />} />
        <Route path="/compliance/rambursuri-curieri" element={<RambursuriCurieriPage />} />
        <Route path="/bani/taxe" element={<TaxeImpozitePage />} />
        <Route path="/bani/verificare-cifre" element={<VerificareCifrePage />} />
        {/* Adresa veche, ca linkurile salvate sa nu duca in gol. */}
        <Route
          path="/compliance/ramburs-fan"
          element={<Navigate to="/compliance/rambursuri-curieri" replace />}
        />
        <Route path="/compliance/facturi-restante" element={<FacturiRestantePage />} />
        <Route path="/emag/dashboard" element={<DashboardEmagPage />} />
        <Route path="/emag/vouchere" element={<VouchereEmagPage />} />
        <Route path="/emag/verificare" element={<VerificareEmagPage />} />
        <Route path="/emag/verificare/runs/:id" element={<VerificareEmagRunDetailPage />} />
        <Route path="/emag/comenzi" element={<ComenziEmagPage />} />
        <Route path="/emag/facturi-vanzare" element={<FacturiVanzareEmagPage />} />
        <Route path="/emag/facturi-cumparare" element={<FacturiCumparareEmagPage />} />
        <Route path="/emag/incasari" element={<IncasariEmagPage />} />
        <Route path="/amazon/facturi-vanzare" element={<FacturiVanzareAmazonPage />} />
        <Route path="/amazon/facturi-comisioane" element={<FacturiComisioaneAmazonPage />} />
        <Route path="/amazon/incasari" element={<IncasariAmazonPage />} />
        <Route element={<DoarEchipaDeconturi />}>
          <Route path="/hr/deconturi" element={<DeconturiHubPage />} />
          <Route path="/hr/deconturi/:id" element={<DeconturiEditorPage />} />
        </Route>
        <Route path="/hr/ordine-deplasare" element={<OrdineDeplasarePage />} />
        <Route path="/hr/incarca-bon" element={<IncarcaBonPage />} />
        <Route path="/operational/comenzi" element={<ComenziPage />} />
        <Route path="/operational/comenzi/:id" element={<ComandaEditPage />} />
        <Route path="/clienti" element={<ClientiiMeiPage />} />
        <Route path="/operational/clientii-mei" element={<Navigate to="/clienti" replace />} />
        <Route path="/clienti/:id" element={<ClientPage />} />
        <Route path="/operational/agenti-preview" element={<AgentiPreviewPage />} />
        <Route path="/operational/cockpit-vanzari" element={<CockpitVanzariPage />} />
        <Route path="/operational/inventar-diferente" element={<InventarDiferentePage />} />
        <Route path="/operational/intrari" element={<IntrariGestiunePage />} />
        <Route path="/operational/expedieri-awb" element={<ExpedieriAwbPage />} />
        <Route element={<DoarCineVedeFlota />}>
          <Route path="/operational/rompetrol" element={<RompetrolPage />} />
          <Route path="/operational/flota/procese-verbale" element={<ProceseVerbalePage />} />
          <Route path="/operational/flota/pv/:id" element={<PvPage />} />
          <Route path="/operational/flota/masini/:id" element={<MasinaPage />} />
          <Route path="/operational/flota/soferi/:userId" element={<SoferPage />} />
        </Route>
        {/* Oricine: serverul ii arata doar masinile si PV-urile in care e parte. */}
        <Route path="/flota/masina-mea" element={<MasinaMeaPage />} />
        <Route path="/operational/sell-out" element={<SellOutPage />} />
        <Route path="/vanzari/discounturi" element={<DiscounturiAcordatePage />} />
        <Route path="/operational/alocare-clienti" element={<AlocareClientiPage />} />
        <Route path="/operational/corespondenta" element={<CorespondentaPage />} />
        {/*
          Filele vechi de task-uri (inlocuite de tabloul pe departamente, 12.10.2026). Adresele
          raman, ca linkurile salvate si notificarile vechi (`?view=<id>`) sa nu duca in gol.
        */}
        {[
          '/task-urile-mele',
          '/operational/triaj',
          '/operational/departament',
          '/operational/in-asteptare',
          '/operational/echipa',
          '/operational/procesate',
        ].map((p) => (
          <Route key={p} path={p} element={<SpreCuParametri to="/task-uri" />} />
        ))}
        <Route
          path="/operational/recurente"
          element={<SpreCuParametri to="/task-uri/recurente" />}
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

/** Redirectionare care pastreaza `?view=<id>`, singurul parametru vechi inca valabil. */
function SpreCuParametri({ to }: { to: string }) {
  const view = new URLSearchParams(useLocation().search).get('view')
  return <Navigate to={view ? `${to}?view=${encodeURIComponent(view)}` : to} replace />
}

function AppShellOutlet() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}

function NotFound() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-semibold">Pagina nu a fost găsită</h1>
        <p className="mt-2 text-b4l-text-muted">404 — alege o pagină din meniu.</p>
      </div>
    </div>
  )
}
